import { useEffect, useState } from "react"
import { get, post } from '@util/xhrAPI'
import Div from '@ui/layout/Div'
import { useTranslation } from "react-i18next"
import { useNavigate, useParams } from 'react-router'
import TextareaType from "@ui/inputs/TextareaType"
import Buttons from '@ui/elements/Buttons'
import Alert from '@ui/elements/Alert'
import { ROLE_PUBLIC } from '@router/Routes'
import { updateNotification } from '@store/slice/mainSlice'
import { useDispatch, useSelector } from "react-redux"
import Icon from "@ui/elements/Icon"
import useFormData from "@hook/useFormData"

const FeedBack = () => {
  const dispatch = useDispatch()
  const { mission } = useSelector(state => state.main)
  const { token, missionScan } = useParams()
  const [isValidToken, setValidToken] = useState(false)
  const feedback = {
    note: 0,
    comment: '',
    token: token,
    missionScan: missionScan,
    mission: mission.id
  }
  const [feedBackState, setFeedBackState] = useState(feedback)
  const [t] = useTranslation('sterilization')
  const navigate = useNavigate()
  const renderFormData = useFormData()

  const updateState = (prop, value) => {
    setFeedBackState({
      ...feedBackState,
      [prop]: value
    })
  }

  const validateFeedback = () => {
    post(`${import.meta.env.VITE_API_URL}/public/feed-backs/save`, renderFormData(feedBackState), response => {
      const { code } = response
      if (200 === code) {
        dispatch(updateNotification({ type: 'is-success', message: t('messages.feedback_saved') }))
        setTimeout(() => {
          navigate(ROLE_PUBLIC['home'])
        }, 4000)
      }
    })
  }

  const renderStars = () => {
    const stars = []
    for (let i = 1; i <= 5; i++) {
      stars.push(<Icon
        key={i}
        icon={i <= feedBackState.note ? 'icon-star' : 'icon-star_outline'}
        spanClass={i <= feedBackState.note ? 'is-selected' : ''}
        callback={() => updateState('note', i)}
      />)
    }
    return (
      <Div cssClass='stars'>
        {stars}
      </Div>
    )
  }

  const renderFeedbackZone = () => {
    return (
      <Div cssClass='feedback-creator'>
        <h2 className='scene-title'>{t('titles.sterilization_feedback')}</h2>
        {renderStars()}
        <TextareaType name='feedback' onChange={e => updateState('comment', e.target.value)} value={feedBackState.comment} placeholder={t('form.feedback')} />
        <Buttons buttons={
          { icon: 'icon-floppy-disk', cssClass: 'is-info is-small', callback: () => validateFeedback(), text: t('actions.save') }
        } />
      </Div>
    )
  }

  useEffect(() => {
    if (token) {
      get(`${import.meta.env.VITE_API_URL}/public/missions/${mission.id}/feed-backs/check/${token}/${missionScan}`, response => {
        const { code } = response
        if (code == 200) {
          setValidToken(true)
        } else {
          setValidToken(false)
        }
      })
    }
  }, [token])

  return (
    <>{isValidToken ? renderFeedbackZone() : <Alert message={t('alerts.invalid_or_already_processed_feedback')} type='is-danger' />}</>
  )
}

export default FeedBack